var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: "新增",
        visible: _vm.dialogVisible,
        width: "800px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c("label", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v("选择年份"),
              ]),
              _c(
                "el-select",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.year,
                    callback: function ($$v) {
                      _vm.year = $$v
                    },
                    expression: "year",
                  },
                },
                _vm._l(_vm.getYear, function (item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("BaseTable", {
            attrs: { tableData: _vm.tableData, height: "535", isPager: false },
            scopedSlots: _vm._u([
              {
                key: "estimateSalesAmount",
                fn: function (row) {
                  return [
                    _c(
                      "el-input",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入",
                          oninput: "value=value.replace(/^\\.+|[^\\d.]/g,'')",
                        },
                        model: {
                          value: row.scope.estimateSalesAmount,
                          callback: function ($$v) {
                            _vm.$set(row.scope, "estimateSalesAmount", $$v)
                          },
                          expression: "row.scope.estimateSalesAmount",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "suffix",
                            attrs: { slot: "suffix" },
                            slot: "suffix",
                          },
                          [_vm._v("万USD")]
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "estimateCustomerCount",
                fn: function (row) {
                  return [
                    _c(
                      "el-input",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入",
                          oninput: "value=value.replace(/^[^\\d]/g,'')",
                        },
                        model: {
                          value: row.scope.estimateCustomerCount,
                          callback: function ($$v) {
                            _vm.$set(row.scope, "estimateCustomerCount", $$v)
                          },
                          expression: "row.scope.estimateCustomerCount",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "suffix",
                            attrs: { slot: "suffix" },
                            slot: "suffix",
                          },
                          [_vm._v("家")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "debounce-click",
                  rawName: "v-debounce-click",
                  value: _vm.ok,
                  expression: "ok",
                },
              ],
              staticClass: "ok flex_c_c",
            },
            [_vm._v(" 确 定 ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }